import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EPackagingType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

/**
 * Pipe regarding the transformation of packaging type enum entries to string.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see PackagingToStringService
 */
@Pipe({
  name: 'packagingToStringPipe',
  standalone: true
})
export class PackagingToStringPipe implements PipeTransform {

  public transform(ePackagingType: EPackagingType): unknown {
    return PackagingToStringService.transform(ePackagingType);
  }

}

/**
 * Pipe regarding the transformation of packaging type enum entries to string.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see PackagingToStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class PackagingToStringService {

  public static transform(ePackagingType: EPackagingType): unknown {
    let text = '';

    switch (ePackagingType) {
      case EPackagingType.RefundableGlasses: {
        text = $localize`:@@PackagingRefundableGlasses:Refundable glasses`;
        break;
      }
      case EPackagingType.DisposableGlasses: {
        text = $localize`:@@PackagingDisposableGlasses:Disposable glasses`;
        break;
      }
      case EPackagingType.Barrels: {
        text = $localize`:@@PackagingBarrels:Barrels`;
        break;
      }
      case EPackagingType.Can: {
        text = $localize`:@@PackagingCan:Can`;
        break;
      }
      case EPackagingType.PET: {
        text = $localize`:@@PackagingPET:PET`;
        break;
      }

      default: {
        throw new Error(`missing enum implementation in packagingToStringPipe for ${ePackagingType}`);
      }

    }

    return text;
  }

}
